'use client'
import React from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

const LinkComponent = ({ href, className, style, children }) => {
    const pathname = usePathname()
    const segments = pathname.split('/')
    let link = href
    const languages = ['en', 'cn', 'th', 'ru', 'fr', 'de', 'it', 'es', 'ja', 'ko', 'tr', 'he', 'ar']
    if (segments.length > 1 && languages.includes(segments[1])) {
        link = `/${segments[1]}${href}`
    }
    return (
        <Link className={className} style={style} href={link}>
            {children}
        </Link>
    )
}

export default LinkComponent